import LiveQueryUseCase from "./LivequeryUseCase";

export function liveQueryUseCase() {
  return new LiveQueryUseCase();
}
